import * as faceapi from 'face-api.js';
import { EventEmitter } from 'events';
import OfflineController from './OfflineController';

declare var navigator: any; // Adicione esta linha para evitar erros de tipo no TypeScript
declare var cordova: any;

// Class built to manage webcamera

// Structure expected to be renderized
// Displays the recording webcamera
// <video
//     id="camera__area--view"
// />

// Canvas needed to take picture
// <canvas
//     id="camera__area--sensor"
// />

// Img to download the image
// <img
//     id="camera_area--visualizer"
// />

export default class CameraController {
    private videoCameraVideoTagId: string;
    private canvasTagId: string;
    private imgTagId: string;
    private canvasFaceTagId: string;
    private intervalFacedetectId: any;
    private emitter: EventEmitter;

    private static messages = {
        accessErrorMessage: 'Não foi possível acessar a câmera.',
        modelsNotLoadedMessage: 'Ocorreu um erro ao fazer o load dos módulos de detecção facial.'
    };

    private getHtmlDevice(htmlElement: string): any {
        return document.querySelector(htmlElement);
    }

    public constructor(videoCameraVideoTagId: string = null, canvasTagId: string = null, imgTagId: string = null, canvasFaceTagId: string = null) {
        this.videoCameraVideoTagId = videoCameraVideoTagId;
        this.canvasTagId = canvasTagId;
        this.imgTagId = imgTagId;
        this.canvasFaceTagId = canvasFaceTagId;
        this.emitter = new EventEmitter();
    }


    // Stop recording camera (hardware)
    public static stopUsingCameraDevice(videoCameraVideoTagId: string): void {
        const camera: any = document.querySelector(videoCameraVideoTagId);
        if (camera) {
            const intervalCheckCamera = setInterval(() => {
                if (camera.srcObject) {
                    const stream = camera.srcObject;
                    const tracks = stream ? stream.getTracks() : [];
        
                    for (const track of tracks) {
                    track.stop();
                    }
                
                    //camera.srcObject = null;

                    clearInterval(intervalCheckCamera);
                }
            })
        }
    }

    // Check if a webcamera device is available
    public static checkCameraAccess(returnStream: boolean = false) {
        return new Promise((resolve, reject) => {
            if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: 'user'}})
                .then((stream) => {
                    if (!returnStream) {
                        const tracks = stream.getTracks();
                        for (const track of tracks) {
                            track.stop();
                        }
                        resolve(null);
                    } else {
                        resolve(stream);
                    }
                })
                .catch((error) => {
                    reject(this.messages.accessErrorMessage);
                });
            }
        })
    };

    // Initiate recording camera
    public initTransmitionCameraDevice(): Promise<MediaProvider> {
        return new Promise(async (resolve, reject) => {
            try {
                const camera: HTMLVideoElement = this.getHtmlDevice(this.videoCameraVideoTagId);
        
                camera.setAttribute('running', '');
        
                // As opções abaixo são necessárias para o funcionamento correto no iOS
                camera.setAttribute('autoplay', '');
                camera.setAttribute('muted', '');
                camera.setAttribute('playsinline', '');
        
                camera.srcObject = await CameraController.checkCameraAccess(true) as MediaProvider;
                resolve(camera.srcObject);
            } catch (error) {
                reject(CameraController.messages.accessErrorMessage);
            }

        });
    }

    // Take picture
    public async takePicture(isPause = true) {
        try {
            const camera = this.getHtmlDevice(this.videoCameraVideoTagId);
            const canvas = this.getHtmlDevice(this.canvasTagId);
            const img = this.getHtmlDevice(this.imgTagId);
        
            canvas.width = camera.videoWidth;
            canvas.height = camera.videoHeight;
            const ctx = canvas.getContext('2d');
        
            // Desenhando e convertendo as dimensões
            ctx.drawImage(camera, 0, 0, canvas.width, canvas.height);
        
            // Criando o JPG
            const dataURI = canvas.toDataURL('image/jpeg'); // O resultado é um BASE64 de uma imagem.
            // img.setAttribute('src', dataURI);
        
            if(isPause) {
                camera.pause();
            }
        
            return dataURI;
        } catch (error) {
            throw CameraController.messages.accessErrorMessage;
        }
    }

    public resume() {
        const camera: HTMLVideoElement = this.getHtmlDevice(this.videoCameraVideoTagId);
        camera.play();
    }

    // Solicitar permissão de acesso à câmera no mobile
    public static checkCameraAccessMobile(): Promise<void> {
        return new Promise((resolve, reject) => {
            const permissions = cordova.plugins.permissions;
            permissions.checkPermission(permissions.CAMERA, (status) => {
                if (!status.hasPermission) {
                    permissions.requestPermission(permissions.CAMERA, (status) => {
                        if (status.hasPermission) {
                            resolve();
                        } else {
                            reject('Permissão de câmera não concedida');
                        }
                    }, (error) => {
                        console.error('Erro ao solicitar permissão de câmera:', error);
                        reject('Erro ao solicitar permissão de câmera');
                    });
                } else {
                    resolve();
                }
            }, (error) => {
                console.error('Erro ao verificar permissão de câmera:', error);
                reject('Erro ao verificar permissão de câmera');
            });
        });
    }
    
    // método para inscrever-se em eventos
    public onDetect(event: string, listener: (...args: any[]) => void): void {
        this.emitter.on(event, listener);
    }

    // método para cancelar a inscrição em eventos
    public offDetect(event: string, listener: (...args: any[]) => void): void {
        this.cancelFaceDetection();
        this.emitter.off(event, listener);
    }


    public async faceDetectLive(): Promise<any> {
        try {

            if (this.intervalFacedetectId) {
                this.cancelFaceDetection();
            }

            this.intervalFacedetectId = setInterval(async () => {
                const camera = this.getHtmlDevice(this.videoCameraVideoTagId);
                const canvasFace = this.getHtmlDevice(this.canvasFaceTagId);

                if(!camera) {
                    this.cancelFaceDetection();
                }

                const detections = await faceapi.detectAllFaces(camera,
                  new faceapi.TinyFaceDetectorOptions());
                
                (this.emitter as any).emit('detections', detections);
          
                // DRAW YOU FACE IN WEBCAM
                /*
                canvasFace.innerHtml = faceapi.createCanvasFromMedia(camera)
                faceapi.matchDimensions(canvasFace,{
                  width: 540,
                  height: 410
                })
          
                const resized = faceapi.resizeResults(detections,{
                    width: 540,
                    height: 410
                })
          
                faceapi.draw.drawDetections(canvasFace,resized);*/
                //faceapi.draw.drawFaceLandmarks(canvasFace,resized);
                //faceapi.draw.drawFaceExpressions(canvasFace,resized);
          
            }, 200);
        } catch (error) {
            this.cancelFaceDetection();
        }
    }

    public cancelFaceDetection(): void {
        clearInterval(this.intervalFacedetectId);
    }

    public async detectFacesInImage(imageUrl: string): Promise<any> {
        try {
            // Carregar a imagem
            const image = await faceapi.fetchImage(imageUrl);
    
            // Detectar rostos na imagem
            const detections = await faceapi.detectAllFaces(image, new faceapi.TinyFaceDetectorOptions());
    
            return detections;
        } catch (error) {
            console.error('Erro ao detectar rostos na imagem:', error);
            throw error;
        }
    }

    public async compareFaces(imageUrl1: string, imageUrl2: string): Promise<boolean> {
        try {
            const detections1 = await this.detectFacesInImage(imageUrl1);
            const detections2 = await this.detectFacesInImage(imageUrl2);

            // Verificar se foram detectados rostos em ambas as imagens
            if (detections1.length === 0 || detections2.length === 0) {
                return false;
            }

            // Comparar os descritores faciais dos rostos detectados
            const descriptors1 = detections1[0].descriptor;
            const descriptors2 = detections2[0].descriptor;
            const distance = faceapi.euclideanDistance(descriptors1, descriptors2);

            // Definir um limite de distância para determinar se os rostos são semelhantes
            const threshold = 0.6;

            return distance <= threshold;
        } catch (error) {
            console.error('Erro ao comparar rostos:', error);
            throw error;
        }
    }

    static monkeyPatchFetch() {
        const originalFetch = window.fetch;
    
        (window as any).fetch = function (url: RequestInfo | URL, options?: RequestInit) {
            // Verifique se a URL é uma string e começa com 'file:///'
            if (typeof url === 'string' && url.startsWith('file:///')) {
                return new Promise((resolve, reject) => {
                    const resolveLocalFileSystemURL = (window as any).resolveLocalFileSystemURL;
                    
                    resolveLocalFileSystemURL(url, (fileEntry: any) => {
                        fileEntry.file((file: any) => {
                            const reader = new FileReader();
    
                            reader.onloadend = function () {
                                resolve(new Response(new Blob([this.result])));
                            };
    
                            reader.onerror = function (error: any) {
                                reject(error);
                            };
    
                            if (url.endsWith('.json')) {
                                reader.readAsText(file);
                            } else {
                                reader.readAsArrayBuffer(file);
                            }
                        }, reject);
                    }, reject);
                });
            }
    
            // Convertendo a URL para string se for uma instância de URL
            const requestUrl = url instanceof URL ? url.toString() : url;
    
            return originalFetch(requestUrl, options);
        };
    }


    /**
     * Inicializa e carrega os modelos de detecção facial no ambiente móvel (Android).
     * 
     * Esta função configura o ambiente para que a biblioteca `face-api.js` possa acessar
     * e processar arquivos de modelos de detecção facial em um aplicativo Cordova/Android.
     * Utiliza o sistema de arquivos local do dispositivo para carregar os modelos de detecção facial
     * necessários a partir da pasta "www/models/" no diretório do aplicativo.
    */
    public static async initLoadFaceModulesMobile(): Promise<void> {
        const modelPath = window.cordova.file.applicationDirectory + "www/models/";
        const resolveLocalFileSystemURL = (window as any).resolveLocalFileSystemURL;

        faceapi.env.monkeyPatch({
            readFile: (filePath: string) =>
                new Promise((resolve, reject) => {
                    resolveLocalFileSystemURL(
                        filePath,
                        (fileEntry: any) => {
                            fileEntry.file(
                                (file: any) => {
                                    const reader = new FileReader();
                                    const fileExtension = filePath.split("?")[0].split(".").pop();

                                    reader.onloadend = function () {
                                        if (fileExtension === "json") {
                                            resolve(this.result as Buffer);
                                        } else {
                                            resolve(new Uint8Array(this.result as ArrayBuffer) as unknown as Buffer);
                                        }
                                    };

                                    if (fileExtension === "json") {
                                        reader.readAsText(file);
                                    } else {
                                        reader.readAsArrayBuffer(file);
                                    }
                                },
                                (error: any) => {
                                    console.error("Erro ao acessar o arquivo:", error);
                                    reject(error);
                                }
                            );
                        },
                        (error: any) => {
                            console.error("Erro ao resolver URL do sistema de arquivos:", error);
                            reject(error);
                        }
                    );
                }),
            Canvas: HTMLCanvasElement,
            Image: HTMLImageElement,
            ImageData: ImageData,
            Video: HTMLVideoElement,
            createCanvasElement: () => document.createElement("canvas"),
            createImageElement: () => document.createElement("img"),
        });

        try {
            await faceapi.nets.tinyFaceDetector.loadFromDisk(modelPath);
            await faceapi.nets.faceRecognitionNet.loadFromDisk(modelPath);
            console.log("Modelos carregados com sucesso no Android!");
        } catch (error) {
            console.error("Erro ao carregar os modelos:", error);
        }
    }
     
    
    /**
     * Inicializa e carrega os modelos de detecção facial.
     * 
     * Esta função verifica se o dispositivo é móvel e, em caso afirmativo, chama a função `initLoadFaceModulesMobile`
     * Caso contrário, carrega os modelos de detecção facial a partir do diretório público
     * no ambiente web.
    */
    public static async initLoadFaceModules() {
        try {
            if(OfflineController.isMobile()) {
                await this.initLoadFaceModulesMobile();
                return;
            }

            await Promise.all([
                // Carrega os modelos de detecção facial a partir do diretório public/models no ambiente web.
                faceapi.nets.tinyFaceDetector.loadFromUri("./models"),
                //faceapi.nets.faceLandmark68Net.loadFromUri("./models"),
                //faceapi.nets.faceRecognitionNet.loadFromUri("./models"),
                //faceapi.nets.faceExpressionNet.loadFromUri("./models")
            ]);

        } catch (error) {
            throw CameraController.messages.modelsNotLoadedMessage;
        }
    }

}
